import React, { createContext, useContext, useState, useEffect } from 'react'
import service from '../service'
import { useAuth } from './auth'

const FlowContext = createContext();

const DEFAULT_FLOW = {
  id: null,
  flowTitle: null
}

const FlowContextProvider = ({ children }) => {
  const [allFlows, setAllFlows] = useState([])
  const [flowDetails, setFlowDetails] = useState(DEFAULT_FLOW)
  const [flowStages, setFlowStages] = useState([])
  const [currentFlowStages, setCurrentFlowStages] = useState([]);
  const [allTypeformForms, setAllTypeformForms] = useState([])
  const [allCustomForms, setAllCustomForms] = useState([])
  const [flowStageTypes, setFlowStageTypes] = useState([])
  const { isLoggedIn } = useAuth()

  useEffect(() => {
    const getTypes = async () => {
      const res = await service.getFlowStageTypes()
      const data = res ? await res.json() : res
      return data
    }
    const fetchTypes = async () => {
      const types = await getTypes()
      const typesArray = Array.isArray(types) ? types : [];
      setFlowStageTypes(typesArray)
    }
    if (isLoggedIn) {
      fetchTypes()
    }
  },[isLoggedIn])

  return (
    <FlowContext.Provider value ={{
      flowDetails, setFlowDetails, flowStages, setFlowStages,
      allFlows, setAllFlows, allTypeformForms, setAllTypeformForms,
      allCustomForms, setAllCustomForms, flowStageTypes, setFlowStageTypes,
      currentFlowStages, setCurrentFlowStages
    }}>
      {children}
    </FlowContext.Provider>
  )
}

const useFlow = () => useContext(FlowContext)

export { useFlow }
export default FlowContextProvider;